package com.gloopgo.game

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import co.touchlab.kermit.Logger
import kotlinx.browser.document


@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    // Initialize Webpack-bundled Firebase App instance before launching UI
    try {
        js("""
            var firebaseApp = require('firebase/app');
            var getApps = firebaseApp.getApps || (firebaseApp.default && firebaseApp.default.getApps);
            var initializeApp = firebaseApp.initializeApp || (firebaseApp.default && firebaseApp.default.initializeApp);
            
            var apps = (typeof getApps === 'function') ? getApps() : [];
            if (!apps || apps.length === 0) {
                var config = {
                    apiKey: "AIzaSyBxtVXMFdoBXM2gqIvS4Wyvi3Rx_SZjl1Q",
                    authDomain: "gloopgo1.firebaseapp.com",
                    databaseURL: "https://gloopgo1-default-rtdb.firebaseio.com",
                    projectId: "gloopgo1",
                    storageBucket: "gloopgo1.firebasestorage.app",
                    messagingSenderId: "1056197607672",
                    appId: "1:1056197607672:web:d5531a83f274cfc68abb0d"
                };
                if (typeof initializeApp === 'function') {
                    initializeApp(config);
                    console.log("Firebase successfully initialized in Kotlin/JS");
                }
            }
        """)
    } catch (e: Throwable) {
        Logger.e(tag = "WebMain") { "Firebase init error: ${e.message}" }
    }

    document.getElementById("loading-spinner")?.remove()

    try {
        js("""
            if (typeof window !== 'undefined') {
                window.addEventListener('contextmenu', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }, { capture: true, passive: false });
            }
        """)
    } catch (_: Throwable) {}

    ComposeViewport(document.body!!) {
        App()
    }
}